import React from "react";
import AppHeader from "../components/AppHeader";
import ToolHeader from "../components/ToolHeader";
import { ConfigProvider } from "antd";
import { designerThemeDark, designerThemeLight } from "../theme";
import { useRecoilState } from "recoil";
import { themeState } from "../lib/atom";
import MapTileButton from "../components/DropDown";

// Layout component that wraps the entire designer UI with headers, theme support, and tool controls
export const DesignerLayout = ({
  children,                // Main content passed into the layout
  type,                    // Controls the visibility of the layout container
  currentProject,          // Current project metadata
  polygonUpdate,           // Polygon data/state from the map or design
  polygonLoading,          // Loading state for the polygon update
  handleUpdatePolygon,     // Callback to trigger polygon updates
  handleGenerateDxf,       // Callback to generate a DXF file
  updateDrawingMode,       // Callback to change drawing mode
  currentDrawingMode,      // Current drawing mode (e.g., select, draw, edit)
  arePanelsOK,             // Boolean to enable/disable UI panels depending on validation
  setCurrentSegment,
  currentSegment,
  currentDesign,
  setShadingValues,
  shadingValues,
  setRemovedSections,
}) => {

  // Read/write Recoil state for the theme (light/dark)
  const [theme, setTheme] = useRecoilState(themeState);

  // Toggle theme between light and dark
  const handleThemeChange = () => setTheme(!theme);

  return (
    // Container div controlling visibility and preventing scroll overflow
    <div style={{ visibility: type, overflow: "hidden" }}>

      {/* Ant Design's theme context based on current theme */}
      <ConfigProvider theme={theme ? designerThemeDark : designerThemeLight}>

        {/* Main application header with theme switch and project info */}
        <AppHeader
            theme={theme}
            handleThemeChange={handleThemeChange}
            currentProject={currentProject}
        />

        {/* Toolbar below the header for drawing tools, polygon updates, and DXF export */}
        <ToolHeader
            theme={theme}
            polygonUpdate={polygonUpdate}
            currentProject={currentProject}
            handleUpdatePolygon={handleUpdatePolygon}
            handleGenerateDxf={handleGenerateDxf}
            updateDrawingMode={updateDrawingMode}
            currentDrawingMode={currentDrawingMode}
            arePanelsOK={arePanelsOK}
            setCurrentSegment={setCurrentSegment}
            currentSegment={currentSegment}
            currentDesign={currentDesign}
            setShadingValues={setShadingValues}
            shadingValues={shadingValues}
            setRemovedSections={setRemovedSections}
        />
        {/*<div style={{ height: "calc(100vh - 74px)", overflow: "hidden" }}>*/}
        
        {/*  /!*<MapDropDownButton options={['Option 1', 'Option 2', 'Option 3']} />*!/*/}
        {/*  {children}*/}
        {/*  <MapToggleButton />*/}

        {/*</div>*/}
        
        {/* Main content container that fills remaining viewport height */}
        <div style={{ position: 'relative', height: "calc(100vh - 92.8px)", overflow: "hidden" }}>
          
          {/* Fixed-position button in the bottom-right corner for selecting map tiles */}
          <div style={{ position: 'fixed', bottom: '8px', right: '8px', zIndex: '999' }}>
            <MapTileButton />
          </div>

          {/* Render passed children (likely the design canvas or map editor) */}
          {children}
        </div>
      </ConfigProvider>
    </div>
  );
};
